export const authorizedUsers = [
    'ryan.olson@fsgi.com',
    'marco.ortes@fsgi.com',
    'chris.roach@fsgi.com',
    'jon.magee@fsgi.com',
    'daryl.schneider@fsgi.com',
    'chris.allen@fsgi.com',
    'adam.haynes@fsgi.com',
    'matthew.mccallon@fsgi.com',
    // 'madison.sterling@fsgi.com',
    // 'madison.shelby@fsgi.com',
    'billg@fsgi.com',
    'robert.davis@fsgi.com',
    'anthony.perry@fsgi.com',
    'mike.cooper@fsgi.com',
    'louis.moore@fsgi.com',
    'tony.barrenda@fsgi.com',
    'daniel.villegas@fsgi.com',
    'jonathan.baker@fsgi.com',
    'allenb@fsgi.com',
    'bobby.graham@fsgi.com',
    'aaron.davis@fsgi.com',
    'stephen.malave@fsgi.com'
]